import { render, staticRenderFns } from "./AddBarTrendWidgetForParentOrg.vue?vue&type=template&id=5233d44a"
import script from "./AddBarTrendWidgetForParentOrg.vue?vue&type=script&lang=js"
export * from "./AddBarTrendWidgetForParentOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports